<script setup lang="ts">
import type { OnActiveItem, UiItem } from './ProductSelectItems.vue'

export type Props = {
  product: Pick<ProductListingFragmentFull, 'id' | 'groupId' | 'privateVisibility' | 'sellerId'> | null
  onActive?: OnActiveItem | None
  onImage?: (img: gen.ImageNodeItemFragment | None) => void
}

const props = defineProps<Props>()
const hoverIndex = shallowRef(-1)

const { products: products1 } = useProductGroup({
  vars: () => {
    const p = props.product
    return { groupId: p?.groupId, privateVisibility: p?.privateVisibility, sellerId: p?.sellerId }
  },
  pricing: 'skip',
})

const products = computed(() => helpers.arr(products1.value))

const currentUi = computed(() => {
  const all = products.value
  const currentId = props.product?.id
  const index = hoverIndex.value === -1 ? all.findIndex((i) => i.id === currentId) : hoverIndex.value

  return helpers.arr(all[index]?.option, (i) => ({ key: i.key + index, name: i.uiKey, value: i.uiValue }))
})

const variantsList = computed(() => {
  const currentId = props.product?.id
  const isImage = products.value.some((i) => !!getListingImg(i))
  return products.value.map((item, index): UiItem & { key: string; index: number; boximage: gen.ImageFragment['image2'] | None } => {
    const img = getListingImg(item)
    return {
      key: item.id,
      index,
      title: item.title,
      name: helpers.joinStringCb('/', item.option, (i) => i.uiValue) || item.title || '',
      isCurrent: currentId === item.id,
      color: '',
      img,
      isImage,
      isColor: false,
      inStock: !!item._values?.inStock,
      productId: item.id,
      slug: item.slug,
      boximage: img,
    }
  })
})

function mouseenter(item: (typeof variantsList.value)[0]) {
  if (item.boximage || item.isCurrent) props.onImage?.(item.boximage)
  hoverIndex.value = item.index
}
function mouseleave() {
  hoverIndex.value = -1
  props.onImage?.(undefined)
}
</script>

<template>
  <div v-if="variantsList.length > 1">
    <div v-if="currentUi.length" class="_hm20">
      <ProductSelectHeader v-for="item in currentUi" :key="item.key" :name="item.name || ''" :value="item.value" :seller-id="undefined" />
    </div>
    <ProductSelectItems :items="variantsList" :mouseenter :on-active :mouseleave />
  </div>
</template>
